export default __webpack_public_path__ + "static/media/icon3.1ee488e5.png";